import { Font } from '@react-pdf/renderer';
import { pdfFontFamily } from './theme';

// Fonts are vendored under public/fonts/pdf (SIL OFL licences alongside) and
// served by the portal itself — no CDN fetch at render time, no 404 risk in
// air-gapped school networks. They are the same families the backend
// Puppeteer templates use (Inter + JetBrains Mono), so FE and BE PDFs read
// as one family.

const DEFAULT_BASE = `${process.env.PUBLIC_URL || ''}/fonts/pdf`;

let registered = false;

/**
 * Register the PDF font families once per session. `baseUrl` defaults to the
 * portal's own public/fonts/pdf folder; it is a parameter only so non-browser
 * renderers (scripts, tests) can point at the same files on disk.
 */
export function registerPdfFonts(baseUrl: string = DEFAULT_BASE): void {
  if (registered) return;
  registered = true;

  Font.register({
    family: pdfFontFamily.sans,
    fonts: [
      { src: `${baseUrl}/Inter-Regular.ttf`, fontWeight: 400 },
      { src: `${baseUrl}/Inter-Italic.ttf`, fontWeight: 400, fontStyle: 'italic' },
      { src: `${baseUrl}/Inter-Medium.ttf`, fontWeight: 500 },
      { src: `${baseUrl}/Inter-SemiBold.ttf`, fontWeight: 600 },
      { src: `${baseUrl}/Inter-Bold.ttf`, fontWeight: 700 },
    ],
  });
  Font.register({
    family: pdfFontFamily.mono,
    fonts: [
      { src: `${baseUrl}/JetBrainsMono-Regular.ttf`, fontWeight: 400 },
      { src: `${baseUrl}/JetBrainsMono-Medium.ttf`, fontWeight: 500 },
      { src: `${baseUrl}/JetBrainsMono-Bold.ttf`, fontWeight: 700 },
    ],
  });

  // Prevent react-pdf from mid-word-breaking long tokens like 13-digit CNICs
  // or email addresses — they bleed past the page edge otherwise.
  Font.registerHyphenationCallback((word) => [word]);
}
